import React from 'react'
import { useForm } from '@inertiajs/react'
import classNames from 'classnames/bind'
import styles from '../UserProfile.module.scss'

const cx = classNames.bind(styles)

interface CancelRemovalButtonProps {
  userId: number
}

export default function CancelRemovalButton({ userId }: CancelRemovalButtonProps) {
  const { delete: destroy, processing } = useForm()

  function handleClick() {
    destroy(`/admin/users/${userId}/removal`)
  }

  return (
    <button
      type="button"
      className={cx('btn', 'btnDanger')}
      disabled={processing}
      onClick={handleClick}
      style={{ marginTop: 8, width: '100%' }}
    >
      {processing ? 'Cancelling…' : 'Cancel removal'}
    </button>
  )
}

